module.exports = __webpack_public_path__ + "orkla-klimatskala-6ab66b9502f28b8d979e086455c0eb0c.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/climate-img/orkla-klimatskala.png
// module id = 38
// module chunks = 0